export default "__VITE_ASSET__Cez3kC7n__"